import styled from 'styled-components';

import { lg } from '../../styles/mixins';

export const Container = styled.div({
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  position: 'relative',
  height: '100%',
  '&:after': {
    background: `linear-gradient(180deg, rgba(0, 0, 0, 0.6) 50%, transparent 100%)`,
    content: "''",
    height: lg(125),
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
});
